import type { CppEditionCollection, EditionItem, Group, Image, PointOfInterest, Set } from '~/types/elements';
import type { CppModel } from '~/types/preview';

const typeMapper: Record<string, string> = {
  news: 'news',
  'sphynx-article': 'edition-special',
  'sphynx-spesial-v2': 'edition-special',
  'sphynx-dnx-article': 'commercial-special',
  article: 'article',
  'edition-cover': 'edition-cover',
  'edition-brief': 'edition-brief',
  'sphynx-spesial': 'edition-special',
  'sphynx-product-placeholder': 'sphynx-product-placeholder',
  'dn-sphynx-v2-cutoff': 'dn-sphynx-v2-cutoff',
  'skandi-front-article': 'news',
  'global-business-front': 'news',
  'cpp-sections-dn': 'cpp-placeholder',
  'cpp-streams-dn': 'cpp-placeholder',
  'cpp-categories-dn': 'cpp-placeholder',
  'cpp-collections-dn': 'cpp-placeholder',
  'cpp-mostread-dn': 'cpp-placeholder',
  'cpp-favorites-dn': 'cpp-placeholder',
  'cpp-embed-common': 'cpp-placeholder',
  'cpp-collections-common': 'cpp-placeholder',
  'cpp-article-custom': 'news',
  'cpp-video-common': 'video',
  Static: 'static',
  'Story with 400 words': 'news',
  'Brief with 100 words': 'news',
  'Comment long 560 words': 'paper',
  'Comment short 325 words': 'paper',
  'Comment wing 250 words': 'paper',
  'Cutting Quote': 'paper',
  'Cuttings flow': 'paper',
  'Cuttings lead': 'paper',
  'Cuttings short stories': 'paper',
  'Finance 500 words': 'paper',
  'Finance_250 words IEA': 'paper',
  'Finance_400 words Baker Hughes': 'paper',
  'Finance_Oil Price 400 words': 'paper',
  Leader: 'paper',
  'Story with 600 words': 'paper',
  'Story with 800 words': 'paper',
  'Wing 200 words': 'paper',
  'Wing 300 words': 'paper',
  'Wing stand alone 200 words': 'paper',
  'Wing stand alone 300 words': 'paper',
  'global-front-article': 'frontarticle',
  'global-reader-engagement': 'readerEngagement',
  placeholder: 'placeholder',
  'cpp-sections-upstream': 'cpp-placeholder',
  'cpp-streams-upstream': 'cpp-placeholder',
  'cpp-categories-upstream': 'cpp-placeholder',
  'cpp-collections-upstream': 'cpp-placeholder',
  'cpp-mostread-upstream': 'cpp-placeholder',
  'cpp-favorites-upstream': 'cpp-placeholder',
  'Lead 400 words': 'news',
  'Lead 600 words': 'news',
  'Lead 800 words': 'news',
  'Second 250 words': 'news',
  'Second 400 words': 'news',
  SponsoredArticle: 'news',
  'global-newsletter-editor-intro': 'newsletter-editor-intro',
  'cpp-sections-intrafish_com': 'cpp-placeholder',
  'cpp-streams-intrafish_com': 'cpp-placeholder',
  'cpp-categories-intrafish_com': 'cpp-placeholder',
  'cpp-collections-intrafish_com': 'cpp-placeholder',
  'cpp-mostread-intrafish_com': 'cpp-placeholder',
  'cpp-favorites-intrafish_com': 'cpp-placeholder',
  'cpp-sections-intrafish_no': 'cpp-placeholder',
  'cpp-streams-intrafish_no': 'cpp-placeholder',
  'cpp-categories-intrafish_no': 'cpp-placeholder',
  'cpp-collections-intrafish_no': 'cpp-placeholder',
  'cpp-mostread-intrafish_no': 'cpp-placeholder',
  'cpp-favorites-intrafish_no': 'cpp-placeholder',
  'cpp-sections-europower': 'cpp-placeholder',
  'cpp-streams-europower': 'cpp-placeholder',
  'cpp-categories-europower': 'cpp-placeholder',
  'cpp-collections-europower': 'cpp-placeholder',
  'cpp-mostread-europower': 'cpp-placeholder',
  'cpp-favorites-europower': 'cpp-placeholder',
  'global-newsletter-intro-article': 'newsletterIntroArticle',
  'cpp-sections-fiskeribladet': 'cpp-placeholder',
  'cpp-streams-fiskeribladet': 'cpp-placeholder',
  'cpp-categories-fiskeribladet': 'cpp-placeholder',
  'cpp-collections-fiskeribladet': 'cpp-placeholder',
  'cpp-mostread-fiskeribladet': 'cpp-placeholder',
  'cpp-favorites-fiskeribladet': 'cpp-placeholder',
  'cpp-sections-hydrogen': 'cpp-placeholder',
  'cpp-streams-hydrogen': 'cpp-placeholder',
  'cpp-categories-hydrogen': 'cpp-placeholder',
  'cpp-collections-hydrogen': 'cpp-placeholder',
  'cpp-mostread-hydrogen': 'cpp-placeholder',
  'cpp-favorites-hydrogen': 'cpp-placeholder',
  'cpp-sections-recharge': 'cpp-placeholder',
  'cpp-streams-recharge': 'cpp-placeholder',
  'cpp-categories-recharge': 'cpp-placeholder',
  'cpp-collections-recharge': 'cpp-placeholder',
  'cpp-mostread-recharge': 'cpp-placeholder',
  'cpp-favorites-recharge': 'cpp-placeholder',
  'cpp-sections-tradewinds': 'cpp-placeholder',
  'cpp-streams-tradewinds': 'cpp-placeholder',
  'cpp-categories-tradewinds': 'cpp-placeholder',
  'cpp-collections-tradewinds': 'cpp-placeholder',
  'cpp-mostread-tradewinds': 'cpp-placeholder',
  'cpp-favorites-tradewinds': 'cpp-placeholder',
  'cpp-embed-dn': 'cpp-placeholder',
  'cpp-embed-europower': 'cpp-placeholder',
  'cpp-audioplaylist-europower': 'cpp-placeholder',
  'cpp-latestnews-common': 'cpp-placeholder',
  'cpp-dataplatform-dn': 'cpp-placeholder',
  'cpp-dataplatform-europower': 'cpp-placeholder',
  'cpp-dataplatform-fiskeribladet': 'cpp-placeholder',
  'cpp-dataplatform-hydrogen': 'cpp-placeholder',
  'cpp-dataplatform-recharge': 'cpp-placeholder',
  'cpp-dataplatform-tradewinds': 'cpp-placeholder',
  'cpp-dataplatform-upstream': 'cpp-placeholder',
  'cpp-dataplatform-intrafish_com': 'cpp-placeholder',
  'cpp-dataplatform-intrafish_no': 'cpp-placeholder',
  'cpp-editortoplist-cutoff': 'cpp-editortoplist-cutoff',
  'cpp-editortoplist-dn': 'cpp-placeholder',
  'cpp-editortoplist-d2': 'cpp-placeholder',
  'cpp-editortoplist-magasinet': 'cpp-placeholder',
  'cpp-editortoplist-upstream': 'cpp-placeholder',
  'cpp-editortoplist-recharge': 'cpp-placeholder',
  'cpp-editortoplist-hydrogen': 'cpp-placeholder',
  'cpp-editortoplist-europower': 'cpp-placeholder',
  'cpp-editortoplist-intrafish_no': 'cpp-placeholder',
  'cpp-editortoplist-intrafish_com': 'cpp-placeholder',
  'cpp-editortoplist-fiskeribladet': 'cpp-placeholder',
  'cpp-editortoplist-tradewinds': 'cpp-placeholder'
};

export default function () {
  const defaultCollection = {
    total: 0,
    size: 0,
    offset: 0,
    metadata: {},
    items: []
  };

  const isFuture = (ts: unknown): boolean => {
    if (ts == null) {
      return true;
    }

    const now = Date.now();
    let timestampMs: number;

    if (typeof ts === 'number') {
      timestampMs = ts;
    } else {
      timestampMs = Date.parse(String(ts));
      if (Number.isNaN(timestampMs)) {
        return true;
      }
    }

    return timestampMs === 0 || timestampMs > now;
  };

  function translate (data: Array<Object>, activeVariant = '', state = ''): CppEditionCollection {
    return data ? buildGroupAndSets(data, activeVariant, state) : defaultCollection;
  }
  function buildGroupAndSets (data: Array<Object>, activeVariant = '', state = ''): CppEditionCollection {
    const editionItems: EditionItem[] = [];
    let items: any[] = []; // regular set items (non group)
    data.forEach((val) => {
      if (val?.group && items.length !== 0) {
        const sets = buildSets(items, activeVariant, state);
        if (sets.length > 0) {
          editionItems.push(...sets);
        }
        items = [];
      }
      if (val?.group && val?.items?.length !== 0) {
        const { items } = val;
        const group: Group = {
          type: 'group',
          data: val.group?.data,
          items: buildSets(items, activeVariant, state)
        };
        if (group?.items?.length > 0) {
          editionItems.push(group);
        }
      } else {
        items.push(val?.item);
      }
    });
    if (items.length > 0) {
      const sets = buildSets(items, activeVariant, state);
      if (sets.length > 0) {
        editionItems.push(...sets);
      }
    }
    return {
      size: editionItems.length,
      total: editionItems.length,
      offset: 0,
      items: editionItems,
      metadata: {}
    };
  }
  function buildSets (items: any[], activeVariant = '', state = ''): Set[] {
    const weights = {
      'A+': 100,
      A: 50,
      B: 25
    };
    const maxItems = 3;
    const setArr: Set[] = [];
    for (let i = 0; i < items.length; ++i) {
      const ts = items[i]?.data?.activatedTimestamp ?? items[i]?.activatedTimestamp;
      const mappedType = typeMapper[items[i]?.data?.type];
      /*
       * The editortoplist cutoff is a structural marker with no activatedTimestamp; never filter it
       * out in published state, or splitAtCutoff can't find it and the after-cutoff feed leaks into the page.
       */
      if (mappedType !== 'cpp-placeholder' && mappedType !== 'cpp-editortoplist-cutoff' && state === 'published' && isFuture(ts)) { continue; }
      let totalWeight = 0;
      const itemSets: CppModel[] = [];
      let layout = '';

      while (i < items.length) {
        const item = items[i];
        try {
          const activeVariantItem = Object.assign({}, item?.data, getActiveVariantData(item, activeVariant));
          const priority = activeVariantItem.priority || ((typeMapper[activeVariantItem.type] === 'cpp-placeholder') ? 'A+' : 'B');
          totalWeight += weights[priority];
          if (totalWeight > 100 || itemSets.length === maxItems) {
            --i;
            break;
          }
          layout += priority;
          itemSets.push(createCppModel(activeVariantItem));
        } catch (e) {
          console.error('Error building a set content with id: ', item?.id);
        }
        ++i;
      }
      setArr.push({
        type: 'set',
        items: itemSets,
        layout
      });
    }
    return setArr;
  }
  function createCppModel (item = {}): CppModel {
    // @ts-ignore
    const cppModel: CppModel = {};
    cppModel.id = item.id;
    buildTitle(cppModel, item);
    buildLead(cppModel, item);
    cppModel.state = item.status || 'published';
    cppModel.type = (item?.lanternType === 'featurearticle' && 'featureArticle') || item.lanternType || typeMapper[item.type] || 'news';
    cppModel.priority = item.priority;
    cppModel.theme = item.backgroundColor;
    cppModel.image_position = item.imagePosition;
    cppModel.mobile_image_position = item.mobileImagePosition;
    buildHideLead(cppModel, item);

    if (item.video && item.video.showVideo) {
      cppModel.video = item.video;
    }
    cppModel.kicker = item.kicker;
    cppModel.meta = item.footer;
    cppModel.image_hide = !!item.imageHide;
    cppModel.mobile_bplus = !!item.mobileBPlus;
    buildFeatures(cppModel, item);
    buildLeadAsset(cppModel, item);
    buildFields(cppModel, item);
    return cppModel;
  }

  function buildHideLead (cppModel: CppModel, item = {}) {
    if (!item['summary-hide'] && (item.priority === 'A+' || item.priority === 'A')) {
      cppModel.hide_lead = false;
    } else {
      cppModel.hide_lead = true;
    }
  }

  function buildLead (cppModel: CppModel, item = {}) {
    const lead = item.summary || '';
    if (typeof lead === 'string') {
      // remove HTML tags from lead if it exists
      cppModel.lead = lead.replace(/<\/?[^>]+(>|$)/g, '');
    } else {
      cppModel.lead = '';
    }
  }

  function buildTitle (cppModel: CppModel, item = {}) {
    const title = item.title || '';
    const parts = title?.match(/<p>(.*?)<\/p>/g)?.map((tag: string) => tag?.replace(/<\/?p>/g, ''));
    if (!parts || parts.length === 0) {
      cppModel.title = title;
      return;
    }
    const first = parts.shift();
    cppModel.title = first + parts.map((text: string) => `<br>${text}`).join('');
  }
  function buildFields (cppModel: CppModel, item = {}) {
    if (cppModel.type === 'cpp-placeholder') {
      cppModel.fields = item;
    }
  }
  function buildFeatures (cppModel: CppModel, item = {}) {
    const features = item?.features || {};
    if (features['image-format']) {
      features['image-format'] = convertImageRatio(features['image-format']);
    }
    cppModel.features = features;
  }
  function buildLeadAsset (cppModel: CppModel, item: any) {
    if (item?.image) {
      const newImage = translateImage(item.image);
      if (newImage) {
        cppModel.lead_asset = newImage;
      }
    }
  }
  function getActiveVariantData (item = {}, activeVariant = '') {
    if (!activeVariant || activeVariant.toUpperCase() === 'A' || !item.variants || !Array.isArray(item.variants)) { return {}; }

    const variant = item.variants.find(v => v.name === activeVariant);

    return variant && variant.data ? { ...variant.data } : {};
  }

  function translateImage (image = {}) {
    if (!image.url) { return null; }
    const originalHeight = image.height || image.baseHeight;
    const originalWidth = image.width || image.baseWidth;

    const pointOfInterest: PointOfInterest = {
      originalWidth,
      originalHeight,
      centerX: image.aoi?.focus?.x / originalWidth,
      centerY: image.aoi?.focus?.y / originalHeight,
      x: image.aoi?.x / originalWidth,
      y: image.aoi?.y / originalHeight,
      width: image.aoi?.width / originalWidth,
      height: image.aoi?.height / originalHeight
    };
    const newImage: Image = {
      type: 'picture',
      src: image.url,
      pointOfInterest,
      originalWidth,
      originalHeight
    };
    return newImage;
  }
  function convertImageRatio (imageStrFormat: string): string {
    switch (imageStrFormat) {
      case 'square':
        return '1x1';
      case 'three-two':
        return '3x2';
      case 'two-three':
        return '2x3';
      case 'four-three':
        return '4x3';
      case 'three-four':
        return '3x4';
      case 'sixteen-nine':
        return '16x9';
      case 'sixteen-ten':
        return '16x10';
      case 'two-one':
        return '2x1';
      case 'three-one':
        return '3x1';
      case 'four-one':
        return '4x1';
      case 'fill':
        return 'fill';
      default:
        return 'auto';
    }
  }

  return {
    translate
  };
}
